module.exports = __webpack_public_path__ + "img/logo.bb424013.png";